import ReactGA from 'react-ga'
import { Env } from '../controller/constant'
import { getLoggedUserInfo } from './methods'
import { WtLoginKey } from '../constants/loginKeys'
import moment from 'moment'
import { Mixpanel } from '../third-party/Mixpanel'
import { LoginValidate } from '../controller/caller'
import { WtAnalytic } from '../constants/analyticsKeys'

ReactGA.initialize(Env.analyticsTrackID)

export const eventObject = {
    $name: getLoggedUserInfo(WtLoginKey.userName),
    $email: getLoggedUserInfo(WtLoginKey.userEmail),
    userId: getLoggedUserInfo(WtLoginKey.userId),
    userEmailVerified: getLoggedUserInfo(WtLoginKey.userEmailVerified),
    userWhatsApp: getLoggedUserInfo(WtLoginKey.userWhatsApp),
    userWhatsAppVerified: getLoggedUserInfo(WtLoginKey.userWhatsAppVerified),
    userRole: getLoggedUserInfo(WtLoginKey.userRole),
    businessId: getLoggedUserInfo(WtLoginKey.businessId),
    businessName: getLoggedUserInfo(WtLoginKey.businessName),
    businessEmail: getLoggedUserInfo(WtLoginKey.businessEmail),
    businessWebsite: getLoggedUserInfo(WtLoginKey.businessWebsite),
    businessOnBoardingStatus: getLoggedUserInfo(WtLoginKey.businessOnBoardingStatus),
    url: window.location.href,
    dateTime: moment().format('MMMM Do YYYY, h:mm:ss a')
}

export function WtEvent(eventKey, actionObj) {
    if (LoginValidate) {
        let eventCreator = getLoggedUserInfo(WtLoginKey.businessName)

        // Google Analytics
        ReactGA.event({ 'category': eventCreator, 'action': eventKey, 'label': window.location.href })
        // End of Google Analytics

        console.log('Mixpanel', eventKey, getLoggedUserInfo(WtLoginKey.userId), getLoggedUserInfo(WtLoginKey.userName), eventObject)
        // Mixpanel
        Mixpanel.identify(getLoggedUserInfo(WtLoginKey.userId))

        Mixpanel.track(eventKey, { ...actionObj })

        Mixpanel.people.set(eventObject)
        // End of Mixpanel
    } else {
        // Google Analytics
        ReactGA.event({ 'category': WtAnalytic.nonLoggedInUser, 'action': eventKey, 'label': window.location.href })
        // End of Google Analytics
    }
}
